import { useCallback, useEffect, useState } from 'react';
import {
    buildMyInformationFields,
    buildRolesFields
} from 'v2/layouts/AccountWorkspaceLayout/components/AccountDetailsSection/constants';
import useTranslation from 'v2/layouts/AccountWorkspaceLayout/hooks/useTranslation';

import useAccount from 'hooks/useAccount';
import useNavigation from 'hooks/useNavigation';
import usePageRoutes from 'hooks/usePageRoutes';
import useUserRoles from 'hooks/useUserRoles';

const useAccountDetails = () => {
    const { resolveUserData, user } = useAccount();
    const { fetchMyRoles } = useUserRoles();
    const { navigate } = useNavigation();
    const { editUserDetailsPage } = usePageRoutes();

    const { EMAIL, FIRST_NAME, LAST_NAME, NOT_PROVIDED, PHONE, ROLES } = useTranslation();

    const [roles, setRoles] = useState<string[]>([]);

    useEffect(() => {
        const loadRoles = async () => {
            setRoles(await fetchMyRoles());
        };

        void resolveUserData();
        void loadRoles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEditMyInformation = useCallback(
        () => navigate(editUserDetailsPage),
        [editUserDetailsPage, navigate]
    );

    return {
        handleEditMyInformation,
        myInformationFields: buildMyInformationFields(
            user,
            { email: EMAIL, firstName: FIRST_NAME, lastName: LAST_NAME, phone: PHONE },
            NOT_PROVIDED
        ),
        rolesFields: buildRolesFields(roles, ROLES, NOT_PROVIDED)
    };
};

export default useAccountDetails;
